import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { TextField, Button } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers"; // For date picker
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../../common-components/CustomSelect";
//import CustomDatePicker from "../../../common-components/CustomDatePicker";
import CustomTextField from "../../../common-components/CustomTextField";
import ActionMessages from "../../../common-components/ActionMessages";
import CustomDatePicker from "../../../common-components/CustomDatePicker";
import Loading from "../../../common-components/Loading";
import {
  getFinancialYears,
  getFinancialYearSettings,
  createFinancialYearVersion,
} from "../../../actions/financial-management-actions";
import { updateFinancialVersionAPI } from "../../../api/financial-management-api";
import {
  getResponse,
  converDateFormatForPicker,
  formatDateBySetting,
} from "../../../shared-resources/utils";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  table: {
    width: "100%",
    marginTop: theme.spacing(1),
    borderCollapse: "collapse",
    backgroundColor: "#e6eaeb", // Milky white background for the table
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: "auto",
  },
  tableHeader: {
    backgroundColor: "#4B5558",
    color: "white",
    fontWeight: "bold",
  },
  tableCell: {
    padding: theme.spacing(1),
    textAlign: "left",
  },
  zebraRow: {
    backgroundColor: "#f5f5f5",
  },
  zebraRowDark: {
    backgroundColor: "#fff",
  },
  searchBox: {
    width: "260px",
    marginBottom: theme.spacing(2),
    display: "block",
    marginLeft: "10px", // Align search box to the left
  },
  editBtn: {
    color: "#ffff",
    border: "1px solid #3599d1",
    padding: "6px 20px !important",
    fontSize: "13px",
    borderRadius: "15px",
    textTransform: "none",
    backgroundColor: "#0176d3",
    cursor: "pointer",
  },
  cancelButton: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginLeft: "10px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  updateBtn: {
    color: "#ffff",
    border: "1px solid #3599d1",
    padding: "6px 20px !important",
    fontSize: "13px",
    borderRadius: "15px",
    textTransform: "none",
    backgroundColor: "#0176d3",
    cursor: "pointer",
  },
  mainContainer: {
    backgroundColor: "#fff",
    justifyContent: "center",
    display: "flex",
    padding: "15px",
    flexDirection: "column",
    borderRadius: "10px",
  },
  createBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginLeft: "8px",
  },

  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "350px",
    height: "auto",
    position: "relative",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },
}));

export default function Versions() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [editingRow, setEditingRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [selectedFinancialYear, setSelctedFinancialYear] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [yearName, setYearName] = useState("");
  const [periods, setPeriods] = useState("");
  const [loading, setLoading] = useState(true);
  const [yearlyData, setYearlyData] = useState([]);
  const [originalYearlyData, setOriginalYearlyData] = useState([]);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [financialYearsList, setFinancialYearsList] = useState([]);
  const [dateFormat, setDateFormat] = useState("dd/MM/yyyy");
  const [isAddnewVersionClick, setIsAddnewVersionClick] = useState(false);

  const financialYearSettingsData = useSelector(
    (state) => state.financialManagementReducer.financialYearSettingsData
  );

  const financialYearsData = useSelector(
    (state) => state.financialManagementReducer.financialYearsData
  );

  const createdFinancialYearData = useSelector(
    (state) => state.financialManagementReducer.createdFinancialYearData
  );

  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData
  );

  useEffect(() => {
    dispatch(getFinancialYearSettings());
  }, []);

  useEffect(() => {
    if (selectedFinancialYear) {
      setLoading(true);
      dispatch(getFinancialYears(selectedFinancialYear));
    }
  }, [selectedFinancialYear]);

  useEffect(() => {
    setDateFormat(
      converDateFormatForPicker(
        getResponse(generalSettingsData, [])?.[0]?.date_format
      )
    );
  }, [generalSettingsData]);

  useEffect(() => {
    if (
      financialYearSettingsData &&
      (financialYearSettingsData.status === 200 ||
        financialYearSettingsData.status === 400)
    ) {
      setLoading(false);
    }
    if (financialYearSettingsData && financialYearSettingsData.status === 200) {
      const ddlData = [];
      financialYearSettingsData.data.forEach((val) => {
        ddlData.push({ id: val.fvsId, text: val.nameOfTheYear });
      });
      setFinancialYearsList(ddlData);
    }
  }, [financialYearSettingsData]);

  useEffect(() => {
    if (
      financialYearsData &&
      (financialYearsData.status === 200 || financialYearsData.status === 400)
    ) {
      setLoading(false);
    }
    if (financialYearsData && financialYearsData.status === 200) {
      setYearlyData(financialYearsData.data);
    }
  }, [financialYearsData]);

  useEffect(() => {
    if (
      createdFinancialYearData &&
      (createdFinancialYearData.status === 200 ||
        createdFinancialYearData.status === 400) &&
      isAddnewVersionClick
    ) {
      setLoading(false);
    }
    if (
      createdFinancialYearData &&
      createdFinancialYearData.status === 200 &&
      isAddnewVersionClick
    ) {
      setEmptyErrMsg(true);
      setMsgType("success");
      setMsgText("New financial year created successfully");
      setShowDialog(false);
      dispatch(getFinancialYearSettings());
      setIsAddnewVersionClick(false);
    }
    if (
      createdFinancialYearData &&
      createdFinancialYearData.status === 400 &&
      isAddnewVersionClick
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(createdFinancialYearData.message);
      setIsAddnewVersionClick(false);
    }
  }, [createdFinancialYearData]);

  const handleEdit = () => {
    setIsEditing(true);
    setOriginalYearlyData(yearlyData.map((item) => ({ ...item })));
  };

  const getDate = (date) => {
    if (date && date !== "") {
      const dateVal = formatDateBySetting(new Date(date), "YYYY-MM-DD");
      return dateVal;
    }
    return null;
  };
  const getTimestamp = (date) => new Date(date).getTime();
  const handleUpdate = () => {
    const findValidationError = yearlyData.find((data) => {
      if (data.openDate && data.closeDate) {
        return getTimestamp(data.openDate) > getTimestamp(data.closeDate);
      }
      return false;
    });
    if (findValidationError) {
      setEmptyErrMsg(true);
      setMsgText("Open date should be less than close date");
      setMsgType("error");
      return;
    } else {
      const updatedYearlyData = [...yearlyData];
      yearlyData.forEach((data, index) => {
        updatedYearlyData[index].isUpdate =
          !findValidationError &&
          (originalYearlyData[index].openDate !== data.openDate ||
            originalYearlyData[index].closeDate !== data.closeDate);
        updatedYearlyData[index].openDate = data.openDate;
        updatedYearlyData[index].closeDate = data.closeDate;
      });
      updateFinancialVersionAPI(updatedYearlyData)
        .then((response) => {
          if (response.status === 200) {
            setEmptyErrMsg(true);
            setMsgType("success");
            setMsgText("financial year updated successfully");
            setIsEditing(false);
          } else {
            setYearlyData([...originalYearlyData]);
            setEmptyErrMsg(true);
            setMsgType("error");
            setMsgText("Unable to update financial year");
            setIsEditing(false);
          }
        })
        .catch((error) => {
          setYearlyData([...originalYearlyData]);
          setEmptyErrMsg(true);
          setMsgType("error");
          setMsgText("Unable to update financial year");
          setIsEditing(false);
        });
    }
  };

  const handleCancel = () => {
    setYearlyData(originalYearlyData);
    setIsEditing(false);
  };

  const handleInputChange = (e) => {};

  // Handle date picker change for OpenDate and CloseDate
  const handleDateChange = (date, index, name) => {
    const updatedData = [...yearlyData];

    if (name === "openDate") {
      updatedData[index].openDate = date
        ? getDate(date)
        : updatedData[index].openDate;
    } else if (name === "closeDate") {
      updatedData[index].closeDate = date
        ? getDate(date)
        : updatedData[index].closeDate;
    }
    setYearlyData(updatedData);
  };

  const handleOnYearSelected = (e) => {
    setSelctedFinancialYear(e.target.value);
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onAddVersion = () => {
    if (new Date(startDate) > new Date(endDate)) {
      setEmptyErrMsg(true);
      setMsgText("Start date shouldn't be greater than end date");
      setMsgType("error");
      return false;
    }
    setLoading(true);
    setIsAddnewVersionClick(true);
    dispatch(
      createFinancialYearVersion({
        nameOfTheYear: yearName,
        startDate: startDate,
        endDate: endDate,
        periodToCreate: periods,
      })
    );
  };

  const onChangeStartDate = (val) => {
    setStartDate(val ? getDate(val) : null);
  };

  const onChangeEndDate = (val) => {
    setEndDate(val ? getDate(val) : null);
  };

  const onAddNew = () => {
    setStartDate(null);
    setEndDate(null);
    setYearName("");
    setPeriods("");
    setShowDialog(true);
  };

  const renderHeaderContainer = () => {
    return (
      <div className={classes.headerContainer}>
        <Grid container>
          <Grid item lg={2}>
            <CustomSelect
              selectedValue={selectedFinancialYear || ""}
              onChangeItem={handleOnYearSelected}
              labelVal="Financial Year"
              id="financialYear"
              items={financialYearsList}
              width="100%"
            />
          </Grid>
          <Grid item lg={4} />
          <Grid item lg={2}>
            <Button
              size="small"
              color="primary"
              variant="contained"
              disableElevation
              className={classes.createBtn}
              onClick={() => onAddNew()}
            >
              Add New Year
            </Button>
          </Grid>
        </Grid>
        {selectedFinancialYear && selectedFinancialYear !== "" && (
          <div>
            {!isEditing && (
              <button className={classes.editBtn} onClick={handleEdit}>
                Edit
              </button>
            )}
            {isEditing && (
              <div style={{ flexDirection: "row", display: "flex" }}>
                <button onClick={handleUpdate} className={classes.updateBtn}>
                  Update
                </button>
                <button onClick={handleCancel} className={classes.cancelButton}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className={classes.mainContainer}>
        {renderHeaderContainer()}
        {/* Table */}
        {selectedFinancialYear && selectedFinancialYear !== "" && (
          <table className={classes.table}>
            <thead>
              <tr className={classes.tableHeader}>
                <th className={classes.tableCell}>
                  <strong>Version Name</strong>
                </th>
                <th className={classes.tableCell}>
                  <strong>Period Name</strong>
                </th>
                <th className={classes.tableCell}>
                  <strong>Open Date</strong>
                </th>
                <th className={classes.tableCell}>
                  <strong>Close Date</strong>
                </th>
                <th className={classes.tableCell}>
                  <strong>Status</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Dynamically render table rows */}
              {yearlyData.map((row, index) => (
                <tr
                  key={index}
                  className={
                    index % 2 === 0 ? classes.zebraRow : classes.zebraRowDark
                  }
                >
                  <td className={classes.tableCell}>{row.versionName}</td>
                  <td className={classes.tableCell}>{row.periodName}</td>
                  <td className={classes.tableCell}>
                    {row.VersionName != "Budget" &&
                    isEditing &&
                    row.status === "Yet to Start" ? (
                      <CustomDatePicker
                        dateFormat={dateFormat}
                        dateValue={row.openDate}
                        setDateValue={(date) =>
                          handleDateChange(date, index, "openDate")
                        }
                        classVal={
                          new Date(row.openDate) > new Date(row.closeDate)
                            ? "datePickerError"
                            : "datePicker"
                        }
                        itemWidth="80%"
                        disableWeekends={false}
                      />
                    ) : row.openDate ? (
                      formatDateBySetting(new Date(row.openDate), dateFormat)
                    ) : (
                      ""
                    )}
                  </td>
                  <td className={classes.tableCell}>
                    {row.VersionName != "Budget" &&
                    isEditing &&
                    (row.status === "Yet to Start" || row.status === "Open") ? (
                      <CustomDatePicker
                        dateFormat={dateFormat}
                        dateValue={row.closeDate}
                        setDateValue={(date) =>
                          handleDateChange(date, index, "closeDate")
                        }
                        classVal={
                          new Date(row.openDate) > new Date(row.closeDate)
                            ? "datePickerError"
                            : "datePicker"
                        }
                        itemWidth="80%"
                        disableWeekends={false}
                      />
                    ) : row.closeDate ? (
                      formatDateBySetting(new Date(row.closeDate), dateFormat)
                    ) : (
                      ""
                    )}
                  </td>
                  <td className={classes.tableCell}>
                    {row.status}
                    {row.VersionName != "Budget" &&
                      row.status === "Yet to Start" && (
                        <button
                          className={classes.editBtn}
                          style={{ marginLeft: "8px" }}
                          onClick={() => {}}
                        >
                          Start
                        </button>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {showDialog && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showDialog}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => setShowDialog(false)}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>Add New Year</div>
            </div>
            <Grid lg={12} spacing={2} className={classes.formGrid}>
              <div className={classes.fieldTitle}>Select Start End</div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={startDate}
                setDateValue={(date) => onChangeStartDate(date)}
                itemWidth="100%"
                classVal="datePicker"
                disableWeekends={false}
              />
            </Grid>
            <Grid lg={12} spacing={2} className={classes.formGrid}>
              <div className={classes.fieldTitle}>Select End Date</div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={endDate}
                setDateValue={(date) => onChangeEndDate(date)}
                itemWidth="100%"
                classVal="datePicker"
                disableWeekends={false}
              />
            </Grid>
            <Grid lg={12} spacing={2} className={classes.formGrid}>
              <div className={classes.fieldTitle}>Name of the Year</div>
              <CustomTextField
                selectedValue={yearName}
                onChangeItem={(e) => setYearName(e.target.value)}
                id="emailIds"
                itemWidth="100%"
              />
            </Grid>
            <Grid lg={12} spacing={2} className={classes.formGrid}>
              <div className={classes.fieldTitle}>Periods to be created</div>
              <CustomTextField
                selectedValue={periods}
                onChangeItem={(e) => setPeriods(e.target.value)}
                id="frequency"
                itemWidth="100%"
              />
            </Grid>
            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.saveBtn}
                variant="contained"
                color="primary"
                onClick={() => onAddVersion()}
                disabled={
                  !startDate ||
                  !endDate ||
                  yearName.toString().trim() === "" ||
                  periods.toString().trim() === ""
                }
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtn}
                color="primary"
                onClick={() => setShowDialog(false)}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </>
  );
}
